module.exports = __webpack_public_path__ + "img/PH1.f8338d6a.png";